import { EventsName } from '@space-lib-events/constants'

export type LogoutError = { origin: string; message: string }

export type LogoutEvent = { detail?: LogoutError }

const logoutEventDispatch = (error?: LogoutError) => {
  window.dispatchEvent(new CustomEvent<LogoutError>(EventsName.LOGOUT, { detail: error }))
}

const logoutEventListener = (listener: (event: LogoutEvent) => void) => {
  window.addEventListener(EventsName.LOGOUT, listener as EventListener)

  return () => {
    window.removeEventListener(EventsName.LOGOUT, listener as EventListener)
  }
}

export { logoutEventDispatch, logoutEventListener }
